<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findBusinessDeviceInfoAdminList.action"
                    ref="intranetDeviceRecordTable">
      <template slot="item">
        <el-table-column
                label="分享时间"
                width="200px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.createTime }}</p>

          </template>
        </el-table-column>
        <el-table-column
                label="设备编号"
                width="200px"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.deviceName }}</p>

          </template>
        </el-table-column>
        <el-table-column
                label="登录账号(内网)"
        >
          <template slot-scope="scope">
            <p>{{scope.row.phone}}- {{scope.row.businessName}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="分享次数"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareCount}}</p>
          </template>
        </el-table-column>
        <el-table-column
                label="分享车源数(去重)"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareModuleCount}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="分享群数(去重)"

        >
          <template slot-scope="scope">
            <p>{{scope.row.shareGroupNameCount}}</p>
          </template>
        </el-table-column>

        <el-table-column
                label="邀请注册"
        >
          <template slot-scope="scope">
            <p>{{scope.row.inviteBusPhoneCount}}</p>
          </template>
        </el-table-column>

      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetDeviceRecord',
  data: function () {
    return {
      queryParams: {
        keyword: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.keyword = query.keyword
  },
  methods: {

  },
  filters: {

  }
}
</script>

<style scoped>
</style>
